import type { HttpUploadProgressEvent } from '@angular/common/http';

import { createActions, ngrxEvent } from '@recruitee/ngrx';

export const HttpActions = createActions('HttpActions', {
  uploadProgress: ngrxEvent<{ uuid: string; event: HttpUploadProgressEvent }>(),
});
